import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from 'react-icons/lib/md/check';

import './TopNavigation.scss';

const stepNames = [
  'Property',
  'Details',
  'Access',
  'Assignment',
  'Attachments',
];
const TopNavigation = ({ stepNumber }) => (
  <div className="row top_navigation">
    <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
      <div className="row">
        <div className="col-12 top_progress_steps">
          <ul className="top_progress_steps__list">
            {stepNames.map((step, index) => (
              <li
                key={step}
                className={`top_progress_steps__list_item ${stepNumber
                  === index
                  ? 'top_progress_steps__list_item-active'
                  : ''}`}
              >
                <div className="top_progress_steps__list_item_bar" />
                {step}
                <span className="top_progress_steps__list_item_icon">
                  <CheckIcon className="top_progress_steps__list_item_iconSvg" />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

TopNavigation.propTypes = {
  stepNumber: PropTypes.number,
};
TopNavigation.defaultProps = {
  stepNumber: 1,
};

export default TopNavigation;
